
import { useCallback } from 'react';
import { useToast } from "@/hooks/use-toast";
import { useSupabase } from "@/hooks/useSupabase";

export const useArticleDislike = () => {
  const { user } = useSupabase();
  const { toast } = useToast();

  const handleDislike = useCallback(async () => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to dislike articles",
        variant: "destructive"
      });
      return;
    }

    toast({
      title: "Noted",
      description: "Thank you for your feedback"
    });
  }, [user, toast]);

  return { handleDislike };
};
